import { useMutation, useQueryClient } from "react-query";

import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";

import { keys } from "./Keys";
import { ISummaryDTO } from "../../services/alarm-scheme-data-service/Models";
import AlarmSchemeAdministrationDataService from "../../services/alarm-scheme-data-service/AlarmSchemeAdministrationService";



type MutationContextType = {
    previousInstances: ISummaryDTO[] | undefined;
};

export type UseDeleteAlarmSchemeParams = {
    organizationID: number,
    groupID: number,
} & BaseUseMutationParameters<void, number>;

export function useDeleteAlarmScheme({
    organizationID,
    groupID,
    onError,
    onSuccess
}: UseDeleteAlarmSchemeParams) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, number, MutationContextType>(
        async (item) => {
            await AlarmSchemeAdministrationDataService.deleteAlarmScheme(
                organizationID,
                groupID,
                item
            );
        },
        {
            onMutate: async (item: number) => {

                await queryClient.cancelQueries(keys.all);

                const previousInstances = queryClient.getQueryData<ISummaryDTO[]>(
                    keys.alarmSchemes(
                        groupID,
                        organizationID
                    )
                );

                queryClient.setQueryData<ISummaryDTO[]>(
                    keys.alarmSchemes(
                        groupID,
                        organizationID
                    ),
                    (old?: ISummaryDTO[]) => {
                        return old?.filter(t => t.id !== item) ?? [];
                    }
                );

                return {
                    previousInstances
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _runTicket, context) => {

                if (error && context?.previousInstances) {
                    queryClient.setQueryData<ISummaryDTO[]>(
                        keys.alarmSchemes(
                            groupID,
                            organizationID
                        ),
                        context?.previousInstances
                    );
                }

                queryClient.invalidateQueries(keys.alarmSchemes(groupID, organizationID));
            }
        }
    );
}
